import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { AwsIntegrationView } from "../../../useSearchCloudIntegrations/gql";

const IntegrationsAwsTableNameCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AwsIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`./${item.id}`}>{item.name}</TableCellLink>
    </TableSimpleCell>
  );
};

export default IntegrationsAwsTableNameCell;
